// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__DhkLG","form-title":"Common_form-title__1tPJN","form-actions":"Common_form-actions__F-sy9"};